"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appearances = exports.APPEARANCES = void 0;
var APPEARANCES = {
  PRIMARY: 'primary',
  OUTLINE: 'outline',
  SUBTLE: 'subtle',
  GHOST: 'ghost',
  INVERSE: 'inverse',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger'
};
exports.APPEARANCES = APPEARANCES;
var appearances = [APPEARANCES.PRIMARY, APPEARANCES.OUTLINE, APPEARANCES.SUBTLE, APPEARANCES.GHOST, APPEARANCES.INVERSE, APPEARANCES.SUCCESS, APPEARANCES.WARNING, APPEARANCES.DANGER];
exports.appearances = appearances;